import { faListSquares } from "@fortawesome/free-solid-svg-icons";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isloading: "idle",
  pageTitle: "Bills",
  currentPage: "defaultPage",
  gettingBillsData: [],
  isShowTransactionHistory: false,
  TransactionImage: "",
  TransactionDescription: "",
  UtilityID: null,
  prepaidRes: null,

  //alfa
  alfa: {
    MobileNumber: null,
    InvoiceId: null,
    displayData: null,
    displayFee: null,
    postpayed: null,
    katshOrderDetailsId: null,
    provider: null,
    referenceKey: null,
    cardList: [],
    prepaid: [],
  },

  sodetel: {
    credential: null,
    cardList: [],
    bundle: null,
    requestId: null,
    identifier: null,
    card: null,
  },

  //touch
  touch: {
    MobileNumber: null,
    InvoiceId: null,
    displayData: null,
    displayFee: null,
    postpayed: null,
    katshOrderDetailsId: null,
    provider: null,
    referenceKey: null,
    cardList: [],
    prepaid: [],
  },

  //ogero
  ogero: {
    MobileNumber: null,
    InvoiceId: null,
    displayBill: null,
    LandlineReqId: null,
    displayedFees: null,
    info: null,
    autoPaystatus: null
  },

  //terranet
  terranet: {
    accountNb: null,
    productList: null,
    selectedCard: null,
  },

  //esim
    esim: {
        esimId: null,
        click:false,
        Price:"",
        name:""
      
    },

};

const BillsSlice = createSlice({
  name: "billsPage",
  initialState,
  reducers: {
    settingBillsData: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    toggleEsimClick: (state, action) => {
      state.esim.click = action.payload;
    },
    EsimPrice: (state, action) => {
      state.esim.Price = action.payload;
    },
    EsimName: (state, action) => {
      state.esim.name = action.payload;
    },
 
 
    
    

    settingBillsObjectData: (state, action) => {
      const { mainField, field, value } = action.payload;
      state[mainField][field] = value;
    },
    updateOgeroInfoAndStatus: (state, action) => {
      const { info, autoPaystatus } = action.payload;
      state.ogero.info = info;
      state.ogero.autoPaystatus = autoPaystatus;
    },    

    restBillsData: (state) => {
      state.isloading = "idle";
      state.pageTitle = "Bills";
      state.currentPage = "defaultPage";
      state.gettingBillsData = [];
      state.isShowTransactionHistory = false;
      state.TransactionImage = "";
      state.TransactionDescription = "";
      state.UtilityID = null;
      state.prepaidRes = null;
      state.alfa = {
        MobileNumber: null,
        InvoiceId: null,
        displayData: null,
        displayFee: null,
        postpayed: null,
        katshOrderDetailsId: null,
        provider: null,
        referenceKey: null,
        prepaid: [],
        cardList: [],
      };
      state.touch = {
        MobileNumber: null,
        postpaidRequestId: null,
        displayData: null,
        displayFee: null,
        postpayed: null,
        katshOrderDetailsId: null,
        provider: null,
        referenceKey: null,
        prepaid: [],
        cardList: [],
      };

      state.ogero = {
        MobileNumber: null,
        InvoiceId: null,
        displayBill: null,
        LandlineReqId: null,
        displayedFees: null,
      };
      state.sodetel = {
        credential: null,
        cardList: [],
        bundle: null,
        requestId: null,
        identifier: null,
        card: null,
      };
    },
  },
});

export const {
  settingBillsData,
  settingBillsObjectData,
  restBillsData,
  toggleEsimClick,
  EsimPrice,
  EsimName,
  updateOgeroInfoAndStatus,
} = BillsSlice.actions;

export default BillsSlice.reducer;
